///<reference path="../../../../typings/angularjs/angular.d.ts"/>
///<reference path="../taskList-module.ts"/>
module TaskList {
    export interface JsonResult {
        success: boolean;
        data: any;
        errorMessage: string;
    }

    export interface IPackageUpdate {
        packageId: string;
        version: string;
    }

    export class TaskListService {
        public getTasks(): ng.IHttpPromise<JsonResult> {
            return this.$http.get(this.getTasksUrl);
        }

        public getPackageUpdates(): ng.IHttpPromise<JsonResult> {
            return this.$http.get<JsonResult>(this.getAvailableUpdatesUrl);
        }

        public getRefreshedPackageUpdates(): ng.IHttpPromise<JsonResult> {
            return this.$http.get<JsonResult>(this.getRefreshedPackageUpdatesUrl);
        }

        public updatePackageFromRepository(packageId: string, packageVersion: string) {
            return this.$http.post<JsonResult>(this.updatePackageFromRepositoryUrl, { packageId: packageId, packageVersion: packageVersion });
        }

        public searchPackages(searchString: string, maxResults?: number) {
            return this.$http.post<JsonResult>(this.packageSearchUrl, { search: searchString, maxResults: maxResults });
        }
        public deletePackage(packageId: string) {
            return this.$http.post<JsonResult>(this.packageDeleteUrl, { packageId: packageId });
        }
        constructor(private $http: ng.IHttpService, private getTasksUrl: string, private getAvailableUpdatesUrl: string, private updatePackageFromRepositoryUrl: string, private getRefreshedPackageUpdatesUrl: string, private packageSearchUrl: string, private packageDeleteUrl: string) {

        }
    }

    app.service("taskListService", ["$http", "getTasksUrl", "getAvailableUpdatesUrl", "updatePackageFromRepositoryUrl", "getRefreshedPackageUpdatesUrl", "packageSearchUrl", "packageDeleteUrl", TaskListService]);
}